import React, { useState, Fragment } from 'react';
import GlobalStyle from './GlobalStyle';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import { getAuth } from './utils/authFunctions';
import Helmet from 'react-helmet';
import { appConstants, LOGOUT_TYPE } from './utils/appConstants';
import { getLogoutURL } from './utils/auth/LogoutManager';
import OIDCAuthManager from './utils/auth/OIDCAuthManager';
import LoggerContext, { logger } from './utils/logger/LoggerContext';

const TitleComponent = () => {
  const defaultTitle = window.location.href.includes(appConstants.URL_FR_LANG)
    ? 'Votre soumission à Manuvie'
    : 'Your submission to Manulife';
  return (
    <Helmet>
      <title>{defaultTitle}</title>
    </Helmet>
  );
};

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    getAuth() && window.location.href.toLowerCase().indexOf('auth') < 0 ? true : false,
  );

  const pathname = window.location.pathname;
  const locale =
    pathname.split('/')[pathname.length - 2] === 'fr' ? appConstants.MANULIFE_FR_LANG : appConstants.MANULIFE_EN_LANG;

  const IDENTITY_CONFIG = {
    // (string): The URL of the OIDC provider.
    authority: window.__ENV__.AUTH_URL,
    // (string): Your client application's identifier as registered with the OIDC provider.
    client_id: window.__ENV__.IDENTITY_CLIENT_ID,
    // The URI of your client application to receive a response from the OIDC provider.
    redirect_uri: window.__ENV__.STEPUP_REDIRECT_URI,
    // (boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint
    // in order to populate the user's profile.
    loadUserInfo: false,
    // (string): The OIDC post-logout redirect URI.
    post_logout_redirect_uri: getLogoutURL(LOGOUT_TYPE.signout, locale, true),
    // (string, default: 'id_token'): The type of response desired from the OIDC provider.
    response_type: 'code',
    // (string, default: 'openid'): The scope being requested from the OIDC provider.
    scope: 'openid ciam',
  };

  const oidc = new OIDCAuthManager(IDENTITY_CONFIG);

  return (
    <Fragment>
      <TitleComponent />
      <GlobalStyle />
      <LoggerContext.Provider value={logger}>
        <BrowserRouter>
          <Routes isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} oidc={oidc} />
        </BrowserRouter>
      </LoggerContext.Provider>
    </Fragment>
  );
};

export default App;
